import { getTvObject } from '@costar-ui/cosmos';
import { focusRing } from '../../../theme/styles/common.esm.js';
import flexOptions from '../../../common/flex-options/flex-options.esm.js';

var variant = getTvObject({
  primary: ['bg-action-primary', 'text-on-action-primary', 'border-transparent', 'hover:bg-action-primary-hover', 'hover:text-on-action-primary-hover', 'pressed:bg-action-primary-active', 'pressed:text-on-action-primary-active', 'disabled:bg-action-disabled', 'disabled:border-disabled'],
  secondary: ['bg-action-base', 'text-on-action-base', 'border-action-base-inverse' /* @mitra review border assignment */, 'hover:bg-action-base-hover', 'hover:text-on-action-base-hover', 'pressed:bg-action-base-active', 'disabled:bg-action-disabled', 'disabled:text-on-action-disabled', 'disabled:border-disabled'],
  tertiary: ['bg-action-alternate', 'text-on-action-alternate', 'border-transparent', 'hover:bg-action-alternate-hover', 'hover:text-on-action-alternate-hover', 'pressed:bg-action-alternate-active', 'pressed:text-on-action-alternate-active', 'disabled:bg-action-disabled', 'disabled:border-disabled'],
  neutral: ['bg-action-base', 'text-on-action-base', 'border-action-neutral', 'hover:bg-action-neutral-hover', 'hover:text-on-action-neutral-hover', 'hover:border-transparent', 'pressed:bg-action-neutral-active', 'disabled:bg-action-disabled', 'disabled:text-on-action-disabled', 'disabled:border-disabled'],
  'neutral-light': ['bg-neutral-subtlest', 'text-action-primary', 'border-transparent', 'hover:bg-action-neutral-hover', 'hover:text-action-primary-hover', 'pressed:bg-action-neutral-active', 'pressed:text-action-primary-active', 'disabled:bg-action-disabled', 'disabled:border-disabled'],
  'ghost-primary': ['text-action-primary', 'bg-transparent', 'border-transparent', 'hover:bg-action-primary-hover', 'hover:text-on-action-primary-hover', 'pressed:bg-action-primary-hover', 'pressed:text-on-action-primary-hover', 'active:bg-action-primary-active', 'active:text-on-action-primary-active', 'disabled:bg-transparent', 'disabled:text-on-action-disabled', 'disabled:border-transparent'],
  'ghost-secondary': ['text-action-base-inverse', 'bg-transparent', 'border-transparent', 'hover:bg-action-base-hover', 'hover:text-on-action-base-hover', 'pressed:bg-action-base-hover', 'pressed:text-on-action-base-hover', 'active:bg-action-base-active', 'active:text-on-action-base-active', 'disabled:bg-transparent', 'disabled:border-transparent'],
  'ghost-secondary-rounded': ['text-action-base-inverse', 'bg-transparent', 'border-transparent', 'hover:bg-action-base-hover', 'hover:text-on-action-base-hover', 'pressed:bg-action-base-hover',
  //pressed: Shows temporary feedback on press/click
  'pressed:text-on-action-base-hover', 'active:bg-action-base-active', 'active:text-on-action-base-active', 'rounded-full'],
  'ghost-neutral': ['text-action-neutral', 'bg-transparent', 'border-transparent', 'hover:bg-action-base-hover', 'hover:text-on-action-base-hover', 'pressed:bg-action-base-active',
  //pressed: Shows temporary feedback on press/click
  'pressed:text-on-action-base-active', 'active:bg-action-base-active',
  //active: Shows temporary feedback on press/click
  'active:text-on-action-base-active', 'disabled:bg-transparent', 'disabled:text-on-action-disabled', 'disabled:border-transparent'],
  'ghost-toggle': ['text-action-neutral', 'bg-transparent', 'border-transparent', 'hover:bg-action-base-hover', 'hover:text-on-action-base-hover', 'aria-pressed:bg-action-selected-subtle',
  //aria-pressed: Indicates toggle state for accessibility & persistent styling
  'aria-pressed:text-action-primary', 'disabled:bg-transparent', 'disabled:text-on-action-disabled', 'disabled:border-transparent'],
  'status-negative': ['bg-status-negative', 'text-on-status-negative', 'border-transparent', 'disabled:bg-action-disabled', 'disabled:border-disabled', 'min-w-16'],
  // temp variant for list view footer
  'button-link': ['text-action-primary', 'bg-transparent', 'border-transparent', 'decoration-primary', 'hover:decoration-primary', 'hover:text-action-primary', 'hover:underline'],
  'menu-item': ['text-action-base-inverse', 'bg-transparent', 'border-transparent', 'hover:bg-accent-hover', 'hover:text-on-accent-hover', 'pressed:bg-accent-hover', 'pressed:text-on-accent-hover', 'active:bg-action-base-active', 'active:text-on-action-base-active', 'disabled:bg-transparent', 'disabled:border-transparent', 'rounded-none', 'h-8', 'p-2', 'w-full'],
  expander: ['bg-transparent', 'disabled:bg-transparent', 'disabled:border-transparent', 'border-x-transparent', 'border-t-transparent', 'border-b-neutral-moderate', 'rounded-none', '!px-0', 'w-full']
});
var tvObject = getTvObject({
  extend: focusRing,
  base: ['relative', 'transition', 'rounded-sm', 'border', 'cursor-pointer', 'disabled:cursor-not-allowed', 'disabled:text-on-action-disabled', 'print:hidden', 'data-[focused]:border-focus'],
  variants: {
    variant: variant,
    color: {
      "default": ['bg', 'text'],
      'status-negative': ['bg-status-negative', 'text-on-status-negative'],
      'status-caution': ['bg-status-caution', 'text-on-status-caution'],
      'status-positive': ['bg-status-positive', 'text-on-status-positive'],
      inherit: ['text-inherit', 'bg-transparent', 'border-transparent']
    },
    size: {
      fit: ['px-2', 'py-1', 'h-fit', 'w-fit', 'text-e-1.0'],
      std: ['p-1.5', 'h-8', 'text-p-16', 'min-w-16'],
      sm: ['py-1', 'px-1.5', 'h-6', 'text-p-14'],
      xs: ['p-0.5', 'h-5', 'text-p-12'],
      /**
       * Zero padding + other fit params to accommodate a button on a text line
       */
      'fit-0-std': ['p-0', 'h-fit', 'text-p-16', 'w-fit'],
      'fit-0-sm': ['p-0', 'h-fit', 'text-p-14', 'w-fit'],
      'icon-fit': ['px-2', 'py-1', 'h-fit', 'w-fit', 'text-p-16'],
      'icon-std': ['p-1', 'h-8', 'w-8', 'min-w-8', 'text-p-16'],
      'icon-sm': ['p-0.5', 'h-6', 'w-6', 'min-w-6', 'text-p-14'],
      'icon-xs': ['p-0.5', 'h-5', 'h-5', 'min-w-5', 'text-p-14']
    },
    orientation: {
      vertical: ['flex', 'flex-col', 'gap-1', 'items-center', 'justify-center'],
      horizontal: ['flex', 'flex-row', 'gap-1', 'flex-nowrap', 'items-center', 'justify-center']
    },
    justify: flexOptions.variants.justify,
    alignItems: flexOptions.variants.alignItems,
    inheritFontSize: {
      "true": 'text-size-inherit'
    },
    inheritColor: {
      "true": 'text-inherit'
    },
    hoverMode: {
      none: ['hover:bg-transparent', 'hover:border-transparent'],
      opacity: ['hover:bg-transparent', 'hover:border-transparent', 'transition-opacity', 'hover:opacity-50']
    },
    noBorder: {
      "true": 'border-0'
    },
    isPending: {
      "true": 'cursor-wait'
    },
    // internal props only do not include in the public type
    nonInteractive: {
      "true": ['active:bg-transparent', 'active:border-transparent', 'pressed:bg-transparent', 'pressed:border-transparent', 'cursor-default']
    }
  },
  compoundVariants: [{
    variant: 'primary',
    nonInteractive: true,
    className: ['hover:bg-action-primary', 'hover:text-on-action-primary', 'hover:border-action-primary', 'pressed:bg-action-primary', 'pressed:text-on-action-primary', 'pressed:border-action-primary', 'outline-0', 'cursor-default']
  }]
});
var baseButton = tvObject;

export { baseButton as default };
//# sourceMappingURL=base-button.esm.js.map
